var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25,0C11.2,0,0,11.4,0,25.4C0,37.3,8.1,47.2,18.9,50c-0.1-0.3-0.2-0.7-0.2-1.2v-4.3c-1,0-2.7,0-3.1,0c-1.7,0-3.2-0.7-4-2.1 c-0.8-1.5-1-3.9-3-5.3c-0.6-0.5-0.1-1,0.6-1c1.3,0.4,2.3,1.3,3.3,2.6c1,1.3,1.5,1.6,3.3,1.6c0.9,0,2.3-0.1,3.5-0.3 c0.7-1.8,1.9-3.4,3.3-4.2c-8.3-0.9-12.3-5.1-12.3-10.8c0-2.5,1-4.8,2.8-6.8c-0.6-2-1.3-6,0.2-7.6c3.7,0,6,2.5,6.6,3.1 c1.9-0.6,3.9-1,6.1-1c2.2,0,4.2,0.4,6.1,1c0.5-0.7,2.8-3.1,6.6-3.1c1.5,1.5,0.8,5.6,0.2,7.6c1.7,2,2.8,4.4,2.8,6.8 c0,5.7-4,9.9-12.3,10.8c2.3,1.2,4,4.6,4,7.2v5.8c0,0.2,0,0.4-0.1,0.6C43,45.9,50,36.5,50,25.4C50,11.4,38.8,0,25,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.36a5bf243c38c939dabbfa49e7ce746f.svg";
export { ForwardRef as ReactComponent };